import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import AdSense from 'react-adsense';
import { ClipLoader } from 'react-spinners';

Modal.setAppElement('#root');

const Ad = () => {

    return (
        <div className="flex items-center justify-center bg-gray-100">
            <img
                src="https://hust.media/img/videos/logout.gif"
                alt="Example"
                className="rounded-full shadow-lg"
            />
        </div>
    );
};




function AdModal({ isOpen, onClose, switch_router }) {

    const [modalStyle, setmodalStyled] = useState(null);
    const [shouldShowAd, setShouldShowAd] = useState(false);
    function fixbengang() {


        // Nếu chiều ngang lớn hơn 700px, sửa lại style cho modal
        if (window.innerWidth >= 1200) {
            setmodalStyled({
                right: '40px',
                left: '300px',
                height: '70%',
                top: '15%',
                width: 'auto',
            })
        }
        else {
            setmodalStyled({
                right: '10px',
                left: '10px',
                height: '70%',
                top: '15%',
                width: 'auto',
            })
        }
    }
    useEffect(() => {
        fixbengang();
        setTimeout(() => {
            setShouldShowAd(true);
        }, 200);

    }, []);
    const [countdown, setCountdown] = useState(4);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (countdown > 0) {
                setCountdown(countdown - 1);
            }
            else {
                window.location.href = '/reactapp/';
            }
        }, 1000);

        return () => clearTimeout(timer);
    }, [countdown]);
    return (
        <>
            <div
                style={{ zIndex: 1 }} >
                <Modal
                    isOpen={isOpen}
                    onRequestClose={onClose}
                    contentLabel="Advertisement"
                    style={{ content: modalStyle }}
                >
                    <div className="cards">
                        {shouldShowAd ? (
                            <>
                                <Ad />
                                <div className="flex justify-between items-center py-0 pr-0">
                                    {/* <Ad /> */}
                                    {countdown > 0 && (
                                        <div className="ml-auto text-sm text-gray-600">
                                            Tự động chuyển sau {countdown} giây
                                        </div>
                                    )}
                                    {countdown === 0 && (
                                        <button
                                            className="ml-auto text-sm bg-pink-200 text-gray-600 px-2 py-1 rounded-md hover:bg-pink-300 focus:outline-none focus:bg-pink-300"
                                            onClick={onClose}
                                        >
                                            Thoát khung
                                        </button>
                                    )}

                                </div>
                            </>
                        ) :
                            (
                                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                                    <ClipLoader size={90} color="#8a2be2" />
                                </div>
                            )

                        }</div>
                </Modal>
            </div>

        </>

    );
};

export default AdModal;
